/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Company } from '../models/Company';
import type { DatahubLoader } from '../models/DatahubLoader';
import type { Survey } from '../models/Survey';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminSurveyService {

    /**
     * get list of surveys
     * @returns Survey Success
     * @throws ApiError
     */
    public static adminListSurveys({
        companyId,
        surveyVendorId,
        surveyJobProfileId,
        userId,
        status,
        batchStatus,
        ingestionJobStatus,
        isPublic,
        search,
        limit,
        offset,
        sort,
    }: {
        /**
         * Company ID
         */
        companyId?: number | null,
        /**
         * Survey Vendor ID
         */
        surveyVendorId?: string | null,
        /**
         * Survey Job Profile ID
         */
        surveyJobProfileId?: string | null,
        /**
         * User ID
         */
        userId?: number | null,
        /**
         * Survey status filter
         */
        status?: 'loaded' | 'detached' | 'empty' | null,
        /**
         * Batch status filter
         */
        batchStatus?: 'staged' | 'committed' | 'rolled_back' | 'scheduled' | 'in_progress' | 'succeeded' | 'failed' | 'paused' | 'cancelled' | null,
        /**
         * Ingestion job status filter
         */
        ingestionJobStatus?: 'files_received' | 'running' | 'needs_action' | 'mapping' | 'data_loader_scheduled' | 'data_loader_in_progress' | 'data_loader_paused' | 'data_loader_failed' | 'cancelled_for_manual' | 'done' | null,
        /**
         * isPublic
         */
        isPublic?: boolean | null,
        /**
         * Search by survey name or code
         */
        search?: string | null,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Sort object
         */
        sort?: {
            name?: string;
            version?: string;
            effectiveDate?: string;
            public?: string;
            user?: string;
            createdAt?: string;
            updatedAt?: string;
        },
    }): CancelablePromise<Array<Survey>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/survey',
            query: {
                'companyId': companyId,
                'surveyVendorId': surveyVendorId,
                'surveyJobProfileId': surveyJobProfileId,
                'userId': userId,
                'status': status,
                'batchStatus': batchStatus,
                'ingestionJobStatus': ingestionJobStatus,
                'isPublic': isPublic,
                'search': search,
                'limit': limit,
                'offset': offset,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create Survey
     * @returns any Success
     * @throws ApiError
     */
    public static createSurvey({
        requestBody,
    }: {
        requestBody: any,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/survey',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get report of surveys
     * @returns any Success
     * @throws ApiError
     */
    public static adminGetReport({
        companyId,
        surveyVendorId,
        surveyJobProfileId,
        userId,
        isPublic,
    }: {
        /**
         * Company ID
         */
        companyId?: number | null,
        /**
         * Survey Vendor ID
         */
        surveyVendorId?: string | null,
        /**
         * Survey Job Profile ID
         */
        surveyJobProfileId?: string | null,
        /**
         * User ID
         */
        userId?: number | null,
        /**
         * isPublic
         */
        isPublic?: boolean | null,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/survey/report',
            query: {
                'companyId': companyId,
                'surveyVendorId': surveyVendorId,
                'surveyJobProfileId': surveyJobProfileId,
                'userId': userId,
                'isPublic': isPublic,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update surveys in bulk
     * @returns any Success
     * @throws ApiError
     */
    public static report({
        requestBody,
    }: {
        requestBody: {
            surveyIds: Array<string>;
            values: Record<string, any>;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/survey/bulkUpdate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * download survey file
     * @returns any Success
     * @throws ApiError
     */
    public static adminDownloadSurveyFile({
        key,
    }: {
        /**
         * key
         */
        key: string,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/survey/download',
            query: {
                'key': key,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * load empty surveys
     * @returns any Success
     * @throws ApiError
     */
    public static loadEmptySurveys({
        requestBody,
    }: {
        requestBody: {
            key: string;
            bucket: string;
            name: string;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/survey/loadEmptySurveys',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * generate survey code
     * @returns string Success
     * @throws ApiError
     */
    public static generateSurveyCode({
        requestBody,
    }: {
        requestBody: {
            surveyJobProfileCode?: string | null;
            tenantId?: string | null;
            version?: string | null;
            effectiveDate?: string | null;
            isPublic?: boolean | null;
        },
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/survey/generateSurveyCode',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update survey
     * @returns any Success
     * @throws ApiError
     */
    public static patchSurvey({
        id,
    }: {
        /**
         * Survey ID
         */
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/survey/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * delete survey
     * @returns any Success
     * @throws ApiError
     */
    public static removeSurvey({
        id,
    }: {
        /**
         * Survey ID
         */
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/survey/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * append survey file
     * @returns any Success
     * @throws ApiError
     */
    public static appendSurveyFile({
        id,
        requestBody,
    }: {
        /**
         * Survey ID
         */
        id: string,
        requestBody: {
            file: {
                key: string;
                bucket: string;
                name: string;
            };
            values?: Record<string, any>;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/survey/{id}/append',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * reload survey file
     * @returns any Success
     * @throws ApiError
     */
    public static reloadFile({
        id,
        requestBody,
    }: {
        /**
         * Survey ID
         */
        id: string,
        requestBody: {
            file: {
                key: string;
                bucket: string;
                name: string;
            };
            values?: Record<string, any>;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/survey/{id}/reload',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * remove survey file
     * @returns any Success
     * @throws ApiError
     */
    public static removeSurveyFile({
        id,
        fileId,
    }: {
        /**
         * Survey ID
         */
        id: string,
        /**
         * File ID
         */
        fileId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/survey/{id}/remove/{fileId}',
            path: {
                'id': id,
                'fileId': fileId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get list of companies with market survey
     * @returns Company Success
     * @throws ApiError
     */
    public static listSurveyCustomers({
        id,
    }: {
        /**
         * Survey ID
         */
        id: string,
    }): CancelablePromise<Array<Company>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/survey/{id}/customers',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get list of dataloaders of a survey
     * @returns DatahubLoader Success
     * @throws ApiError
     */
    public static listSurveyDataLoaders({
        id,
        isMarketPlace,
    }: {
        /**
         * Survey Market ID
         */
        id: string,
        /**
         * Is Market Place
         */
        isMarketPlace?: boolean,
    }): CancelablePromise<Array<DatahubLoader>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/survey/{id}/dataLoaders',
            path: {
                'id': id,
            },
            query: {
                'isMarketPlace': isMarketPlace,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * add survey to customers
     * @returns any Success
     * @throws ApiError
     */
    public static addEntitlements({
        id,
        requestBody,
    }: {
        /**
         * Survey ID
         */
        id: string,
        requestBody: {
            companyIds?: Array<number>;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/survey/{id}/addEntitlements',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * remove survey to customers
     * @returns any Success
     * @throws ApiError
     */
    public static removeEntitlements({
        id,
        requestBody,
    }: {
        /**
         * Survey ID
         */
        id: string,
        requestBody: {
            companyIds?: Array<number>;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/survey/{id}/removeEntitlements',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * check survey exists by code
     * @returns any Success
     * @throws ApiError
     */
    public static adminCheckExists({
        requestBody,
    }: {
        requestBody: {
            code?: string;
        },
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/survey/checkExists',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
